export class QuestionType {
    Name: string;
    ItemGuid: string;
}
export enum QuestionTypeEnum {
    ProjectType = 'ProjectType',
    WoodCondition = 'WoodCondition',
    WoodType = 'WoodType',
    WoodGrain = 'WoodGrain',
    StainGoal = 'StainGoal',
    ProductQuality = 'ProductQuality',
    WoodDamage = 'WoodDamage'
}



// WEBPACK FOOTER //
// ./src/app/models/question-type.ts